import { chatClientApiBaseUrl } from "@config/config";

export type UploadedAttachmentFile = {
  url: string;
  filename: string;
  size: number;
  mediaType?: string;
};

export type UploadAttachmentFilesParams = {
  files: File[];
  authHeaders: Record<string, string>;
  fingerprint?: string | number | null;
  baseUrl?: string;
};

function resolveUploadApiBaseUrl(baseUrl?: string): string {
  if (baseUrl) {
    return baseUrl;
  }
  const env = process.env.NEXT_PUBLIC_ENV as keyof typeof chatClientApiBaseUrl;
  return chatClientApiBaseUrl[env] || chatClientApiBaseUrl.prod;
}

/**
 * Upload files to chat attachments API (shared by Sender and portfolio screenshot modal).
 */
export async function uploadAttachmentFiles({
  files,
  authHeaders,
  fingerprint,
  baseUrl,
}: UploadAttachmentFilesParams): Promise<UploadedAttachmentFile[]> {
  if (files.length === 0) {
    return [];
  }

  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  const apiBase = resolveUploadApiBaseUrl(baseUrl);
  const res = await fetch(`${apiBase}/attachments/upload`, {
    method: "POST",
    headers: {
      ...authHeaders,
      ...(fingerprint ? { guestId: String(fingerprint) } : {}),
    },
    body: formData,
  });

  if (!res.ok) {
    throw new Error(`Upload failed: ${res.status}`);
  }

  const json = (await res.json()) as {
    success?: boolean;
    data?: UploadedAttachmentFile[];
  };

  if (!json.success || !Array.isArray(json.data)) {
    throw new Error("Upload response invalid");
  }

  return json.data;
}
